import React, { Component } from 'react';
//import { FacebookLogin } from 'react-facebook-login-component';
import GoogleLogin from 'react-google-login';
import { browserHistory } from 'react-router';
import Cookies from 'universal-cookie';
import language from '../../../assets/languages/language';
import { examRedirectRoute } from '../../Common/examRedirectRoute';
import FD from '../../RestAPI/fetchData';
import App_data from '../../config/App_data';
import './Auth.css';
import ForgotModal from './ForgotModal';
import AppRoutes from '../../config/AppRoutes';
import GoogleBtn from "../../../components/GoogleBtn";
import {parseIdToken} from "../../../common/helper";
import userStore from "../../../store/userStore";
import {connectSocket} from "../../../services/WebSocketService";
const UserStore = require('../../../store/userStore');

/* eslint-disable*/
class SignIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      displaytext: 'hide_block',
      message: '',
      emailErrorMessage: '',
      passwordErrormessage: '',
      forgotOpenStatus: false,
      urlToRedirect: '',
      passwordtype: 'password',
      // qq_user_code:this.props.qq_user_code,
      // qq_user_nickname:this.props.qq_user_nickname,
      // qq_user_image_url:this.props.qq_user_image_url
    };
    this.loginToDashboard = this.loginToDashboard.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updatePassword = this.updatePassword.bind(this);
  }

  socialQQLogin(e) {
    e.preventDefault();
    var data = { idname: '1223' };
    FD.callAPI(App_data.backend_api + '/user/socialLoginQQ', data).then((resp) => {
      if (resp.success) {
        window.open(resp.result, '_self');
      }
    });
  }

  componentDidMount() {
    {
      this.props.urlToRedirect !== null
        ? this.setState({ urlToRedirect: this.props.urlToRedirect })
        : this.setState({ urlToRedirect: null });
    }
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      var data = {
        token: storage_session['token'],
        idname: storage_session['idname'],
      };
      FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then((resp) => {
        if (resp.success) {
          if (resp.profileInfo.exam) {
            localStorage.setItem(
              'selectedmenu',
              resp.profileInfo.exam === 'cfa_2023' ? 'cfa_2024' : resp.profileInfo.exam,
            );
            browserHistory.push({
              pathname:
                resp.profileInfo.role === 'employee' && resp.profileInfo.exam === 'frm'
                  ? AppRoutes.FRM_V2_DASHBOARD
                  : examRedirectRoute[resp.profileInfo.exam],
              state: {
                token: data.token,
                idname: data.idname,
              },
            });
          }
        } else {
          localStorage.clear();
        }
      });
    }
  }

  componentDidUpdate() {}

  componentWillReceiveProps() {
    this.setState({
      message: '',
      emailErrorMessage: '',
      passwordErrormessage: '',
    });
  }
  updateEmail(e) {
    var email_lower = e.target.value.toLowerCase();
    this.setState({
      message: '',
      emailErrorMessage: '',
      email: email_lower,
    });
  }

  updatePassword(e) {
    this.setState({
      message: '',
      passwordErrormessage: '',
      password: e.target.value,
    });
  }

  loginToDashboard(event) {
    event.preventDefault();
    this.setState({ isDisabled: true });

    const { email, password, urlToRedirect } = this.state;
    const landingSource = localStorage.getItem('landingSource');
    const landingSourceName = localStorage.getItem('landingSourceName');

    if (!email) {
      this.setState({
        displaytext: 'show_block',
        emailErrorMessage: language.LC().Email_is_Required,
        isDisabled: false,
      });
      return;
    }

    const emailValid = /\S+@\S+\.\S+/.test(email);
    if (!emailValid) {
      this.setState({
        displaytext: 'show_block',
        emailErrorMessage: language.LC().Email_Id_Invalid,
        password: '',
        isDisabled: false,
      });
      return;
    }

    if (!password) {
      this.setState({
        displaytext: 'show_block',
        passwordErrormessage: language.LC().Password_is_Required,
        isDisabled: false,
      });
      return;
    }

    this.setState({
      displaytext: 'hide_block',
      message: '',
      emailErrorMessage: '',
      passwordErrormessage: '',
    });

    const role = localStorage.getItem('role');
    const organizationDomain = localStorage.getItem('organizationDomain');
    const loginData = { idname: email, password, role, organizationDomain };

    FD.callAPI(App_data.backend_api + '/user/login', loginData)
      .then((resp) => {
        if (!resp || !resp.success) {
          this.setState({
            displaytext: 'show_block',
            message: resp.message || 'Login failed',
            isDisabled: false,
          });
          localStorage.clear();
          return;
        }
        userStore.setToken(resp.token);
        connectSocket(resp.token);

        localStorage.setItem('loginID', resp.loginID);
        localStorage.setItem(
          'localstorageval',
          JSON.stringify({ token: resp.token, idname: email }),
        );
        localStorage.setItem('selectedmenu', 'cfa_2025');

        if (!resp.exam_details) {
          browserHistory.push({
            pathname: '/selectexam',
            state: { token: resp.token, idname: email, landingSource, landingSourceName },
          });
          this.setState({ isDisabled: false });
          return;
        }

        const processProfileInfo = (profileInfo) => {
          console.log("Profile Info sign in: ", profileInfo);
          if (profileInfo != null) {
            const examMapping = {
              cfa: 'cfa_2024',
              cfa_2022: 'cfa_2024',
              cfa_2023: 'cfa_2024',
              cfa_3: 'cfa_3_2025',
              cfa_2_2022: 'cfa_2_2023',
            };
            const selectedExam = examMapping[profileInfo.exam] || profileInfo.exam;
            localStorage.setItem('selectedmenu', selectedExam);
            browserHistory.push({
              pathname: urlToRedirect || examRedirectRoute[selectedExam],
              state: { token: resp.token, idname: email },
            });
          }
        }

        userStore.getUserProfile()
            .then(processProfileInfo)
            .finally(() => {
              this.setState({ isDisabled: false });
            })

        // FD.callAPI(App_data.backend_api + '/user/getProfileInfo', {
        //   token: resp.token,
        //   idname: email,
        // })
        //   .then((profileResponse) => {
        //     if (profileResponse && profileResponse.success && profileResponse.profileInfo) {
        //       userStore.setProfileInfo(profileResponse);
        //       const examMapping = {
        //         cfa: 'cfa_2024',
        //         cfa_2022: 'cfa_2024',
        //         cfa_2023: 'cfa_2024',
        //         cfa_3: 'cfa_3_2025',
        //         cfa_2_2022: 'cfa_2_2023',
        //       };
        //       const selectedExam =
        //         examMapping[profileResponse.profileInfo.exam] || profileResponse.profileInfo.exam;
        //       localStorage.setItem('selectedmenu', selectedExam);
        //       browserHistory.push({
        //         pathname: urlToRedirect || examRedirectRoute[selectedExam],
        //         state: { token: resp.token, idname: email },
        //       });
        //     }
        //     this.setState({ isDisabled: false });
        //   })
        //   .catch(() => this.setState({ isDisabled: false }));
      })
      .catch((err) => {
        console.error('Login API failed:', err);
        this.setState({ isDisabled: false, message: 'Something went wrong. Please try again.' });
      });
  }

  async responseGoogleGIS(response) {
    const role = localStorage.getItem('role');
    const organizationDomain = localStorage.getItem('organizationDomain');
    const landingSource = localStorage.getItem('landingSource');
    const landingSourceName = localStorage.getItem('landingSourceName');

    const idPayload = parseIdToken(response.credential || '');
    const email = idPayload.email || '';
    const name = idPayload.name || '';

    const data = {
      credential: response.credential,
      role,
      organizationDomain,
    };

    try {
      const resp = await FD.callAPI(
          App_data.backend_api + '/user/v2/loginWithSocialMedia',
          data
      );
      if (!resp.success) {
        if (resp.partner && resp.message) {
          alert(resp.message);
        } else {
          alert('Login failed. Please try again.');
        }
        return;
      }

      if (resp.loginID) {
        localStorage.setItem('loginID', resp.loginID);
      }

      userStore.setToken(resp.token);

      connectSocket(resp.token);

      const cookies = new Cookies();
      cookies.set('token', resp.token, { path: '/', maxAge: 60 * 60 * 24 });
      if (email) cookies.set('idname', email, { path: '/', maxAge: 60 * 60 * 24 });

      const localStorage_array = { token: resp.token, idname: email };
      localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));

      if (resp.user_data == null) {
        localStorage.setItem('signup', 1);
        browserHistory.push({
          pathname: '/selectexam',
          state: {
            token: resp.token,
            idname: email,
            name: name || email,
            landingSource,
            landingSourceName,
          },
        });
        return;
      }

      const prof = await userStore.getUserProfile();

      if (!prof.exam) {
        console.log('getProfileInfo failed or exam missing');
        // fallback — select exam
        localStorage.setItem('signup', 1);
        browserHistory.push({
          pathname: '/selectexam',
          state: {
            token: resp.token,
            idname: email,
            name: name || email,
            landingSource,
            landingSourceName,
          },
        });
        return;
      }

      const ex = prof.exam;
      const normalized =
          ex === 'cfa_2023'
              ? 'cfa_2024'
              : ex === 'cfa_2_2022' || ex === 'cfa_2'
                  ? 'cfa_2_2023'
                  : ex === 'cfa_3'
                      ? 'cfa_3_2025'
                      : ex;

      localStorage.setItem('selectedmenu', normalized);

      const targetPath =
          prof.role === 'employee' && prof.exam === 'frm'
              ? AppRoutes.FRM_V2_DASHBOARD
              : examRedirectRoute[normalized];

      browserHistory.push({
        pathname: targetPath,
        state: { token: resp.token, idname: email },
      });
    } catch (err) {
      console.error('GIS login error', err);
      alert('Login failed. Please try again.');
    }
  }

  responseGoogle(response) {
    const role = localStorage.getItem('role');
    const organizationDomain = localStorage.getItem('organizationDomain');
    const landingSource = localStorage.getItem('landingSource');
    const landingSourceName = localStorage.getItem('landingSourceName');
    const userData = JSON.parse(localStorage.getItem('userData'));

    var data = {
      name: response.profileObj.name,
      email: response.profileObj.email,
      token: response.accessToken,
      imageUrl: response.profileObj.imageUrl,
      organizationDomain: organizationDomain,
      role: role,
    };
    FD.callAPI(App_data.backend_api + '/user/loginWithSocialMedia', data)
      .then(function (resp) {
        if (resp.success) {
          localStorage.setItem('loginID', resp.loginID);
          var localStorage_array = {
            token: resp.token,
            idname: response.profileObj.email,
          };
          const cookies = new Cookies();
          cookies.set('token', resp.token, {
            path: '/',
            maxAge: 60 * 60 * 24,
          });
          cookies.set('idname', response.profileObj.email, {
            path: '/',
            maxAge: 60 * 60 * 24,
          });
          localStorage.setItem('localstorageval', JSON.stringify(localStorage_array));
          if (resp.user_data == null) {
            localStorage.setItem('signup', 1);
            browserHistory.push({
              pathname: '/selectexam',
              state: {
                token: resp.token,
                idname: response.profileObj.email,
                name: response.profileObj.name,
                landingSource: landingSource,
                landingSourceName: landingSourceName,
              },
            });
          } else {
            var data = { token: resp.token, idname: response.profileObj.email };
            FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then((resp) => {
              if (resp.success) {
                if (resp.profileInfo.exam) {
                  localStorage.setItem(
                    'selectedmenu',
                    resp.profileInfo.exam === 'cfa_2023'
                      ? 'cfa_2024'
                      : resp.profileInfo.exam === 'cfa_2_2022' || resp.profileInfo.exam === 'cfa_2'
                        ? 'cfa_2_2023'
                        : resp.profileInfo.exam === 'cfa_3'
                          ? 'cfa_3_2025'
                          : resp.profileInfo.exam,
                  );
                  browserHistory.push({
                    pathname:
                      resp.profileInfo.role === 'employee' && resp.profileInfo.exam === 'frm'
                        ? AppRoutes.FRM_V2_DASHBOARD
                        : examRedirectRoute[resp.profileInfo.exam],
                    state: {
                      token: resp.token,
                      idname: response.profileObj.email,
                    },
                  });
                }
              } else {
                console.log('fail');
              }
            });
          }
        } else if (!resp.success && resp.partner) {
          alert(resp.message);
        }
      })
      .catch(function (err) {});
  }

  failedGoogle(response) {
    console.log('Failed googles login::', response);
    if (response.details === 'Cookies are not enabled in current environment.') {
      alert(
        "We've detected a problem with your cookie settings in the browser. Make sure that your cookies are enabled.",
      );
    }
  }

  handleForgot = () => {
    this.setState({
      forgotOpenStatus: !this.state.forgotOpenStatus,
      message: '',
      emailErrorMessage: '',
      passwordErrormessage: '',
    });
  };

  toggleHandleForgot = (status) => {
    this.setState({ forgotOpenStatus: !status });
  };

  togglepassword = () => {
    if (this.state.passwordtype === 'password') {
      this.setState({ passwordtype: 'text' });
      return;
    }
    this.setState({ passwordtype: 'password' });
    console.log(this.state.passwordtype);
  };

  render() {
    const { isDisabled = false } = this.state;
    return (
      <div className='signin-block'>
        <div className='social-button-tile '>
          <GoogleBtn
              onSuccess={this.responseGoogleGIS}
              onError={this.failedGoogle}
          />
          {/*<GoogleLogin*/}
          {/*  className='social-button pointer_class'*/}
          {/*  style={{ width: 100 + '%' }}*/}
          {/*  clientId='104176560344-vjgtqbi1ga22rf4646q2pvrj73okfagb.apps.googleusercontent.com'*/}
          {/*  buttonText={*/}
          {/*    <div>*/}
          {/*      <span className='social-button-img'>*/}
          {/*        <img src={App_data.frontend_url + '/img/google-plus.png'} alt='' />*/}
          {/*      </span>*/}
          {/*      Sign in with Google*/}
          {/*    </div>*/}
          {/*  }*/}
          {/*  onSuccess={this.responseGoogle}*/}
          {/*  onFailure={this.failedGoogle}*/}
          {/*/>*/}
          {/* <FacebookLogin
            socialId='1173641119363130'
            language='en_US'
            scope='public_profile,email'
            responseHandler={this.responseFacebook}
            xfbml={true}
            fields='id,email,name,picture'
            version='v2.5'
            style={{ width: 100 + '%' }}
            className='social-button pointer_class'
          >
            <div>
              <span className='social-button-img'>
                <img src={App_data.frontend_url + '/img/facebook.png'} alt='' />
              </span>
              Sign in with Facebook
            </div>
          </FacebookLogin> */}
        </div>
        {/* ) : null} */}

        <div className='sign-in-input-tile'>
          {/* {domainApp !== 'WORLD' ? (
            <div className='social-button-tile china-social-button'>
              <button
                className='social-button w-100 pointer_class'
                onClick={this.socialQQLogin.bind(this)}
              >
                <div>
                  <span className='social-button-img'>
                    <img src={App_data.frontend_url + '/img/qq.svg'} alt='' />
                  </span>{' '}
                  登陆使用 QQ
                </div>
              </button>
            </div>
          ) : null} */}

          <form onSubmit={this.loginToDashboard}>
            <p className={this.state.displaytext + ' text-danger'}>{this.state.message}</p>
            <div className='form-group'>
              <input
                type='text'
                className='form-control'
                placeholder={language.LC().USERNAME_OR_EMAIL}
                value={this.state.email}
                onChange={this.updateEmail}
              />
              <p className={this.state.displaytext + ' text-danger'}>
                {this.state.emailErrorMessage}
              </p>
            </div>
            <div className='form-group'>
              <div className='passwordeye_wrapper'>
                <input
                  type={this.state.passwordtype}
                  className='form-control'
                  placeholder={language.LC().PASSWORD}
                  value={this.state.password}
                  onChange={this.updatePassword}
                />
                {this.state.passwordtype === 'password' ? (
                  <img
                    onClick={this.togglepassword}
                    src={App_data.frontend_url + '/img/hide2.png'}
                    alt=''
                  />
                ) : (
                  <img
                    onClick={this.togglepassword}
                    src={App_data.frontend_url + '/img/show 2.png'}
                    alt=''
                  />
                )}
              </div>
              <p className={this.state.displaytext + ' text-danger'}>
                {this.state.passwordErrormessage}
              </p>
            </div>
            <div className='forgot-password pointer_class' onClick={this.handleForgot}>
              {' '}
              {language.LC().FORGOT_PASSWORD}
            </div>
            <ForgotModal
              forgotOpen={this.state.forgotOpenStatus}
              onToggle={this.toggleHandleForgot}
            />
            <button
              className='btn btn-primary sign-in-button btn-block'
              disabled={isDisabled}
              type='submit'
              id='my-btn'
            >
              {isDisabled && <i className='fa fa-spinner fa-spin' />} {language.LC().SIGN_IN}
            </button>
          </form>
        </div>
      </div>
    );
  }
}
export default SignIn;



// WEBPACK FOOTER //
// ./src/views/Pages/Auth/SignIn.js